import type { FC } from "react";
import React from "react";
import { Desktop, Mobile, useTranslation } from "@edreamsodigeo/frontend-core";

import LightboxOfferDesktop from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/LightboxOfferDesktop";
import LightboxOfferMobile from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/LightboxOfferMobile";
import type { LightboxOfferProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/contracts";
import { renewalTimeKey } from "~/tools/subscriptionUtils";

export const LightboxOffer: FC<LightboxOfferProps> = ({
  offerTab,
  onTabChange,
  basicOffer,
  plusOffer,
  freeTrialDays = 0,
}) => {
  const { t } = useTranslation();
  const renewalTime = t(renewalTimeKey(basicOffer?.renewalDuration));
  const textBasic = {
    title: t("lightboxPrimeRevampDesktop.plan.primebasic"),
    duration: renewalTime,
    freeTrial: t("visibility.lightbox.free.trial", {
      freeTrialDays: freeTrialDays,
    }),
  };
  const textPlus = {
    title: t("lightboxPrimeRevampDesktop.plan.primeplus"),
    duration: renewalTime,
    freeTrial: t("visibility.lightbox.free.trial", {
      freeTrialDays: freeTrialDays,
    }),
  };

  return (
    <>
      <Mobile>
        <LightboxOfferMobile
          offerTab={offerTab}
          onTabChange={onTabChange}
          basicOffer={basicOffer}
          plusOffer={plusOffer}
          text={{ textBasic, textPlus }}
          freeTrialDays={freeTrialDays}
        />
      </Mobile>
      <Desktop>
        <LightboxOfferDesktop
          basicOffer={basicOffer}
          plusOffer={plusOffer}
          freeTrialDays={freeTrialDays}
          text={{ textBasic, textPlus }}
        />
      </Desktop>
    </>
  );
};
